import ChatGPT from './ChatGPT';
export default ChatGPT;
